import React, { useEffect, useState } from "react";
import ArrowLeft from "../assets/img/arrow-left.svg";
import Add from "../assets/img/add.svg";
import Minus from "../assets/img/minus.svg";
import AcreditacionesTable from "../components/AcreditacionesVerificados/AcreditacionesTable";
import CheckboxLabel from "../components/CheckboxLabel";
import { Link, useNavigate, useParams } from "react-router-dom";
import Button from "../components/Button";
import Disclaimer from "../components/Disclaimer";
import Alerta from "../assets/img/alerta.svg";
import AcreditacionesGrid from "../components/AcreditacionesVerificados/AcreditacionesGrid";
import { useFetch, usePost } from "../hooks";
import Loading from "../components/Loading";
import { fireGenericErrorModal, firePostSuccessModal } from "../utils/swals";

const AcreditacionesVerificado = () => {
  const [selectedPeriodistas, setSelectedPeriodistas] = useState([]);
  const [checkboxes, setCheckboxes] = useState([false, false, false]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isListOpen, setIsListOpen] = useState(false);

  const { id } = useParams();
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, [id]);

  const navigate = useNavigate();
  const { postJson, isLoading: postLoading } = usePost();

  const { data, isLoading: getLoading } = useFetch(`/getPreacreditados`);

  const handleCheckboxValues = (index) => {
    const newValues = [...checkboxes];
    newValues[index] = !newValues[index];
    setCheckboxes(newValues);
  };


  const handleSubmit = async () => {
    if (isSubmitting) return;
    setIsSubmitting(true);

    try {
      const result = await postJson(`/crear-solicitud-v`, {
        comentarios: null,
        preacreditados: selectedPeriodistas.map((per) => per.id),
        idEvento: id,
      });

      if (result.status === "OK") {
        firePostSuccessModal(() => navigate("/"), result.solicitudId);
      } else {
        fireGenericErrorModal();
        setIsSubmitting(false);
      }

      return result;
    } catch (error) {
      fireGenericErrorModal(error.message);
      setIsSubmitting(false);
    }
  };

  return (
    <div className="bg-gray">
      <div className="general-container">
        <Link to={"/"} className="volver">
          <img src={ArrowLeft} alt="" />
          <h6>Volver a Próximos eventos</h6>
          {console.log(selectedPeriodistas)}
        </Link>
        {getLoading || !data ? (
          <Loading />
        ) : (
          <div className="acreditaciones-box">
            <h1>
              Acreditaciones:{window.innerWidth < 768 && <br />} ¿A quién vas a
              sumar?
            </h1>
            <div className={`add-accordion ${isListOpen ? "open" : "close"}`}>
              <div className="head" onClick={() => setIsListOpen(prev => !prev)}>
                <span>
                  Periodistas preacreditados
                  {selectedPeriodistas.length > 0 && ` (${selectedPeriodistas.length} seleccionados)`}
                </span>
                <img src={isListOpen ? Minus : Add} alt="" />
              </div>
              <div className="body">
                {window.innerWidth > 768 ? (
                  <AcreditacionesTable
                    periodistas={data.preacreditados}
                    selectedPeriodistas={selectedPeriodistas}
                    setSelectedPeriodistas={setSelectedPeriodistas}
                    maxPreacreditados={data.maxPreacreditados}
                  />
                ) : (
                  <AcreditacionesGrid
                    periodistas={data.preacreditados}
                    selectedPeriodistas={selectedPeriodistas}
                    setSelectedPeriodistas={setSelectedPeriodistas}
                    maxPreacreditados={data.maxPreacreditados}
                  />
                )}
              </div>
            </div>
            <div>
              <Disclaimer
                pathIcono={Alerta}
                title={"Atención"}
                subtitle={
                  "Alcanzaste el máximo permitido de periodistas a acreditar "
                }
                variant={"warning"}
                isVisible={selectedPeriodistas.length >= data.maxPreacreditados}
              />
              <CheckboxLabel
                label={
                  "Declaro que los datos consignados en este formulario son correctos y completos; he confeccionado esta declaración sin falsear ni omitir dato alguno, siendo fiel expresión de la verdad."
                }
                handleCheckboxChange={handleCheckboxValues}
                index={0}
              />
            </div>
            <CheckboxLabel
              label={
                "Nueva línea de aviso legal. Arrow selection share asset flatten rotate component. List figjam image rectangle bullet. Vector effect horizontal rotate figjam bold outline group flatten pixel."
              }
              handleCheckboxChange={handleCheckboxValues}
              index={1}
            />
            <CheckboxLabel
              label={
                "Tomo conocimiento y acepto la <span class='fw600 text-underline'>Normativa de Prensa</span> del Club atlético River Plate."
              }
              handleCheckboxChange={handleCheckboxValues}
              index={2}
            />
            <Button
              isDisabled={
                selectedPeriodistas.length === 0 ||
                postLoading ||
                isSubmitting ||
                !checkboxes.every(Boolean)
              }
              variant={`login-btn ${
                selectedPeriodistas.length === 0 ||
                postLoading ||
                isSubmitting ||
                !checkboxes.every(Boolean)
                  ? ""
                  : "enabled"
              }`}
              onClick={handleSubmit}
            >
              Confirmar acreditación
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default AcreditacionesVerificado;
